import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { ClientDevice } from '@ps/platform-message-framework/common/ClientDevice';
import { OSId } from '@ps/platform-message-framework/common/OSId';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Cookie, License } from '@ps/web-core-enums';

import type { RootState, SelectorCreator, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';

import type { NotificationState } from './index';

const selectors = (slice: Slicer<NotificationState>, createSelector: SelectorCreator) => ({
  getIssuedById() {
    return createSelector(
      slice,
      (rootState: RootState, id: string | number) => id,
      (state, id) => state.issued[id]
    );
  },
  getExpiringById() {
    return createSelector(
      slice,
      (rootState: RootState, id: string | number) => id,
      (state, id) => state.expiring[id]
    );
  },
  getClearedById() {
    return createSelector(
      slice,
      (rootState: RootState, id: number) => id,
      (state, id) => state.cleared[id]
    );
  },
  getCounters() {
    return slice((state) => state.counters);
  },
  getCookies() {
    return (rootState: RootState) => rootState.notification.cookies;
  },
  shouldShowSessionReminder() {
    return createSelector(
      slice,
      (rootState: RootState) => select.cms.getBrandId(rootState),
      (rootState: RootState) => select.account.getLicense(rootState),
      (state, brand, license) => brand === BrandTypes.STARS_CASINO && [License.UK].includes(license)
    );
  },
  showDownloadBanner() {
    return createSelector(
      slice,
      (rootState: RootState) => select.cms.getBrandId(rootState),
      (rootState: RootState) => select.device.getId(rootState) === ClientDevice.PHONE,
      (rootState: RootState) => select.cms.getSiteId(rootState) === Sites.DE_SH,
      (rootState: RootState) => select.device.getOS(rootState) === OSId.I_OS,
      (rootState: RootState) => select.account.isRealMoneyOK(rootState),
      (notification, brand, isPhone, isDESH, isIOS, isRealMoneyOK) =>
        isPhone &&
        !!notification.cookies[Cookie.DOWNLOAD_BANNER] &&
        ((brand === BrandTypes.STARS_CASINO && !isDESH && !isIOS && isRealMoneyOK) ||
          brand === BrandTypes.BET_STARS)
    );
  },
  get() {
    return slice;
  }
});

export default selectors;
